import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { useNavigation } from "react-router-dom";

/**
 * Indeterminate progress bar that appears beneath the navbar whenever
 * asynchronous work is in progress:
 *
 * - **Route navigation** — react-router is loading a lazy route module.
 * - **Data fetching** — a react-query query or mutation is in flight.
 *
 * Gives immediate visual feedback so users know the app is working.
 */
export function NavigationProgress() {
  const { state } = useNavigation();
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();

  const isActive = state === "loading" || isFetching > 0 || isMutating > 0;

  if (!isActive) return null;

  return (
    <div
      role="progressbar"
      aria-label="Loading"
      className="absolute inset-x-0 -bottom-0.5 h-0.5 overflow-hidden bg-primary/20"
    >
      <div className="h-full w-1/3 animate-nav-progress bg-primary" />
    </div>
  );
}
